import { cmsBlockViewMap } from '../components/blocks/cms-block-view-map';

import css from './cms-blocks-page-view.css';

import type { CMSBlocksPageContent } from '@/src/cms/domain/models/pages/cms-blocks-page-content';

interface CMSBlocksPageViewProps {
  content?: CMSBlocksPageContent;
}

export function CMSBlocks_PageView({ content }: CMSBlocksPageViewProps) {
  return (
    <div className={css.page}>
      <div className={css.blocksList}>
        {content?.blocks.map((p, index) => {
          const BlockView = cmsBlockViewMap[p.$type];
          // @ts-expect-error - TypeScript does not know about the dynamic import of components
          return <BlockView {...p} key={`${p.$type}-${index}`} />;
        })}
      </div>
    </div>
  );
}
